import { render, staticRenderFns } from "./application_features.vue?vue&type=template&id=bdeeba30&scoped=true&"
import script from "./application_features.vue?vue&type=script&lang=js&"
export * from "./application_features.vue?vue&type=script&lang=js&"
import style0 from "./application_features.vue?vue&type=style&index=0&id=bdeeba30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdeeba30",
  null
  
)

export default component.exports